import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DownloadIcon from '@mui/icons-material/Download';

interface ImportOptionsDialogProps {
  open: boolean;
  onClose: () => void;
  onImportClick: () => void;
  onDownloadTemplateClick: () => void;
  title?: string;
}

const ImportOptionsDialog: React.FC<ImportOptionsDialogProps> = ({
  open,
  onClose,
  onImportClick,
  onDownloadTemplateClick,
  title = 'ייבוא נתונים'
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          בחר את הפעולה הרצויה:
        </Typography>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <Button
            variant="contained"
            startIcon={<UploadFileIcon />}
            onClick={() => {
              onImportClick();
              onClose();
            }}
            fullWidth
            sx={{ py: 1.5 }}
          >
            ייבוא נתונים מקובץ CSV
          </Button>
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={() => {
              onDownloadTemplateClick();
              onClose();
            }}
            fullWidth
            sx={{ py: 1.5 }}
          >
            הורד קובץ תבנית CSV
          </Button>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>ביטול</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImportOptionsDialog;
